import { render, staticRenderFns } from "./CaptureDiscussionRealTime.vue?vue&type=template&id=46c10656"
import script from "./CaptureDiscussionRealTime.vue?vue&type=script&lang=js"
export * from "./CaptureDiscussionRealTime.vue?vue&type=script&lang=js"
import style0 from "./CaptureDiscussionRealTime.vue?vue&type=style&index=0&id=46c10656&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports